<template>
  <div class="about">
    <h1>Boomer's got swag.</h1>
  </div>
</template>
